
import Vue, { PropType } from 'vue';
import { RouterProps } from '@/config/types';
import { Wrapper } from './styles';

export default Vue.extend({
  name: 'Bradcrumb',
  components: {
    Wrapper,
  },
  data() {
    return {
      title: '',
    };
  },
  props: {
    routes: {
      type: Array as PropType<RouterProps[]>,
      default: () => [],
    },
  },
});
